import React from 'react';
import { CheckIcon, GlobeIcon, UsersIcon } from 'lucide-react';
import { CtaBlock } from '../CtaBlock';
const included = [{
  label: '6 MANUALI MAESTRI',
  value: 'VALORE $492'
}, {
  label: '5 BONUS ESCLUSIVI',
  value: 'VALORE $245'
}];
const guarantees = ['Pagamento unico', 'Nessun abbonamento', 'Accesso immediato', 'Accesso a vita'];
export function Offer() {
  return <section className="bg-ink-800 px-4 py-14 sm:px-6 sm:py-20" data-id="element-201" data-mp="3a5oxy0hbb9tf">
      <div className="mx-auto max-w-3xl" data-id="element-202" data-mp="3a3cm8525dvot">
        <p className="text-center font-display text-xs font-bold uppercase tracking-[0.22em] text-forge-light" data-id="element-203" data-mp="3f407ea3p3ib4">
          🏆 Offerta speciale di lancio
        </p>
        <h2 className="mt-3 text-center font-display text-3xl font-bold uppercase leading-tight text-bone sm:text-5xl" data-id="element-204" data-mp="3jxmdtkj9mpyh">
          Tutto ciò che riceverai oggi
        </h2>

        <div className="mt-8 overflow-hidden rounded-2xl border border-ink-500 bg-ink-700" data-id="element-205" data-mp="3sxhug4vlbd5w">
          <ul className="divide-y divide-ink-500" data-id="element-206" data-mp="1q5axj78inmt">
            {included.map(item => <li key={item.label} className="flex items-center justify-between gap-3 px-4 py-4 sm:px-6" data-id="element-207" data-mp="1km9lf1zd43t1">
                <span className="font-display text-lg font-bold uppercase text-bone sm:text-xl" data-id="element-208" data-mp="1bks45ga7xw2r">
                  {item.label}
                </span>
                <span className="shrink-0 font-display text-sm font-bold uppercase text-mute line-through sm:text-base" data-id="element-209" data-mp="16n9vlr045iva">
                  {item.value}
                </span>
              </li>)}
          </ul>
          <div className="flex items-center justify-between gap-3 bg-ink-600 px-4 py-4 sm:px-6" data-id="element-210" data-mp="1zch4njx71qus">
            <span className="font-display text-base font-bold uppercase leading-tight text-mute sm:text-lg" data-id="element-211" data-mp="1uhjm9me0y558">
              Valore totale del sistema
            </span>
            <span className="shrink-0 font-display text-2xl font-bold text-mute line-through sm:text-3xl" data-id="element-212" data-mp="2n0qm69ndjsg4">
              $737 USD
            </span>
          </div>
        </div>

        <p className="mt-8 text-center font-display text-xl font-bold uppercase text-bone sm:text-2xl" data-id="element-213" data-mp="314z3ywvqshgb">
          Ma oggi non pagherai $737…
        </p>

        <div className="mt-5 rounded-2xl border-2 border-forge bg-ink-900 p-6 text-center sm:p-9" data-id="element-214" data-mp="366oca4rkyh0p">
          <h3 className="font-display text-xl font-bold uppercase leading-tight text-arc-light sm:text-2xl" data-id="element-215" data-mp="2sb2rk9sdqje3">
            Accedi oggi al Sistema Maestro di Saldatura™
          </h3>
          <p className="mt-3 font-display text-6xl font-bold leading-none text-bone sm:text-8xl" data-id="element-216" data-mp="2idengt8vvzj9">
            $27
            <span className="ml-2 align-middle text-2xl text-mute sm:text-3xl" data-id="element-217" data-mp="2nbzkykwr4540">USD</span>
          </p>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1.5" data-id="element-218" data-mp="29ge3qzwrepm5">
            {guarantees.map(item => <li key={item} className="text-[12px] font-semibold text-mute sm:text-sm" data-id="element-219" data-mp="7n7oolkyzfdc">
                <CheckIcon className="mr-1 inline h-3.5 w-3.5 text-arc-light" aria-hidden="true" data-id="element-220" data-mp="bojhezz54gpr" />
                {item}
              </li>)}
          </ul>

          <div className="mt-6 rounded-xl border border-arc/40 bg-arc/10 px-4 py-3" data-id="element-221" data-mp="1w6u1cusgmasi">
            <p className="flex items-start justify-center gap-2 text-left text-[13px] font-semibold leading-snug text-bone sm:text-center" data-id="element-222" data-mp="1s6a6xyz9tla2">
              <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-arc-light" aria-hidden="true" data-id="element-223" data-mp="215ng0qjhg7u9" />
              Il cambio di valuta è automatico: pagherai l’equivalente nella tua valuta locale.
            </p>
          </div>

          <div className="mt-4 rounded-xl border border-forge/50 bg-forge/10 px-4 py-4" data-id="element-224" data-mp="2avzy8c3trox8">
            <p className="flex items-center gap-2 font-display text-sm font-bold uppercase tracking-wide text-forge-light" data-id="element-225" data-mp="2ouzlpgflpxrt">
              <UsersIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-226" data-mp="2jx7uypqp0hp7" />
              Restano solo 12 posti al prezzo promozionale
            </p>
            <div className="mt-2.5 h-3 w-full overflow-hidden rounded-full bg-ink-600" role="progressbar" aria-valuenow={94} aria-valuemin={0} aria-valuemax={100} aria-label="Posti assegnati al prezzo promozionale" data-id="element-227" data-mp="uj1o6bqnmqbr">
              <div className="h-full w-[94%] rounded-full bg-forge" data-id="element-228" data-mp="10xgwxiktzko2" />
            </div>
            <p className="mt-2 text-left text-[12px] font-semibold text-mute" data-id="element-229" data-mp="10vntsd9ffikt">
              94% dei posti già assegnati · al termine il prezzo torna a $47
            </p>
          </div>

          <p className="mt-5 text-[14px] leading-relaxed text-mute" data-id="element-230" data-mp="86qb491azjrj">
            Meno del costo di molti piccoli acquisti per la tua officina — e avrai una risorsa
            digitale da consultare ogni volta che ne avrai bisogno.
          </p>

          <div className="mt-7" data-id="element-231" data-mp="mxz5swk2bvbj">
            <CtaBlock note="" data-id="element-232" data-mp="mzacp58t1j6v" />
          </div>
        </div>
      </div>
    </section>;
}